<template>
  <div class="menu-item p-t-20 p-b-20 p-r-10 p-l-10" @click="showModal">
    <menu-item-image :images="menuItem.images" :unavailable="unavailable"> </menu-item-image>
    <div class="menu-item__content">
      <div>
        <h4 class="menu-item__title">{{ menuItem.name }}</h4>
        <p v-if="isDescriptionVisible" class="menu-item__description">
          {{ menuItem.description }}
        </p>
      </div>
      <div v-if="!hidePrice" class="menu-item__price m-l-50">
        <span>{{ prependUsdSign(menuItem.cost) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { prependUsdSign } from "@/utils";
import MenuItemImage from "../menu-item-image/MenuItemImage";
import VendorMenuModal from "@/components/modal/vendor-menu-modal/VendorMenuModal";
import pickupTimeMixin from "@/mixins/pickup-time.mixin";
import { DISPLAY, trackProductClicks } from "@/utils";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "VendorMenuItemDefault",
  components: { MenuItemImage },
  mixins: [pickupTimeMixin],
  props: {
    hidePrice: Boolean,
    unavailable: Boolean,
    menuItem: Object
  },
  computed: {
    ...mapGetters({
      isVendorOpen: "vendor/isActiveVendorOpen",
      getShowHideStatus: "vendor/getShowHideStatus"
    }),
    isDescriptionVisible() {
      return this.menuItem.showDesc && this.menuItem.description;
    },
    /**
     * This method indicates if the UI should allow the user to add items to the cart or not
     *
     * @return {boolean}
     */
    isAddToCartEnable() {
      const pickupTimeEnabled = this.activeVendor.pickupTimeSelectionEnabled;

      if (this.isVenueOrderAheadAllowed && pickupTimeEnabled && this.isVendorOpen) {
        return this.isAnyPickupAvailable(this.activeVendor.id);
      }
      return this.isVendorOpen;
    }
  },
  methods: {
    ...mapActions("cart", ["selectItem", "selectDefaultModifiers"]),
    prependUsdSign,
    getModalProps: function () {
      if (window.innerWidth <= DISPLAY.minDesktopWidth) {
        return {
          name: "item",
          position: "absolute",
          top: "0",
          left: "0"
        };
      }
      return {
        name: "item",
        height: "auto",
        width: 500
      };
    },
    showModal: function (itemQuantity = null) {
      if (this.isAddToCartEnable) {
        this.$modal.show(
          VendorMenuModal,
          {
            menuItem: this.menuItem,
            itemQuantity: itemQuantity
          },
          {
            ...this.getModalProps()
          }
        );

        // this.selectItem(this.menuItem.id);
        // this.selectDefaultModifiers();
        trackProductClicks(this.menuItem);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.menu-item {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  font-family: $fontFamilyPrimary;
  cursor: pointer;
  border-bottom: 1px solid $border-color;

  &__title {
    margin-left: 10px;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
  }

  &__description {
    color: $text-color;
    word-break: break-word;
  }

  &:hover {
    background-color: rgba($border-color, 0.2);
  }
}
</style>
